"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _a, _b, _c;

var React = require("react");

var hs_web_style_guide_1 = require("@headspace/hs-web-style-guide");

var Icon_1 = require("../../icons/Icon");

var FooterListContainer_1 = require("./FooterListContainer");

var FooterList_1 = require("./FooterList");

var FooterListItem_1 = require("./FooterListItem");

var arrowUp = require("../../icons/arrow-up.svg");

var instagram = require("../../icons/instagram.svg");

var twitter = require("../../icons/twitter.svg");

var facebook = require("../../icons/facebook.svg");

var youtube = require("../../icons/youtube.svg");

var colors_1 = require("@headspace/hs-web-style-guide/dist/colors");

var font = require("@headspace/hs-web-style-guide/dist/font");

var grid = require("@headspace/hs-web-style-guide/dist/grid");

var utils = require("@headspace/hs-web-style-guide/dist/utils");

var spacing = require("@headspace/hs-web-style-guide/dist/spacing");

var text = require("@headspace/hs-web-style-guide/dist/text-utils");

var flexStyles = require("@headspace/hs-web-style-guide/dist/flex");

var breakpoints = require("@headspace/hs-web-style-guide/dist/breakpoints");

var hideMobileDisplay = hs_web_style_guide_1.css((_a = {}, _a[breakpoints.maxWidths.s] = {
  display: 'none'
}, _a));
var displayDesktopInline = hs_web_style_guide_1.css((_b = {}, _b[breakpoints.minWidths.m] = {
  display: 'inline-block'
}, _b));
var mobileLogo = hs_web_style_guide_1.css({
  height: '48px',
  width: '48px',
  backgroundColor: colors_1.jaffa,
  borderRadius: '100%',
  display: 'inline-block'
});
var displayFooterLogo = hs_web_style_guide_1.css((_c = {}, _c[breakpoints.minWidths.s] = {
  display: 'none'
}, _c));

var HomepageFooter =
/** @class */
function (_super) {
  __extends(HomepageFooter, _super);

  function HomepageFooter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  HomepageFooter.prototype.render = function () {
    return React.createElement("footer", __assign({}, spacing.default.paddingTopLarge, spacing.default.paddingBottomMedium), React.createElement("div", __assign({}, displayFooterLogo, grid.default.container, spacing.default.paddingBottomLarge), React.createElement("div", __assign({}, mobileLogo, spacing.default.marginAuto))), React.createElement("nav", __assign({}, spacing.default.paddingBottomSmall, hideMobileDisplay, font.uppercase, font.utility4, text.default.cometColor, grid.default.container, flexStyles.default.flex, flexStyles.default.flexWrapWrap, flexStyles.default.justifyContentSpaceBetween), React.createElement("div", __assign({}, grid.default.col2m), React.createElement(FooterListContainer_1.FooterListContainer, {
      title: "get some headspace"
    }, FooterList_1.columnOneLinks.map(function (link, index) {
      return React.createElement(FooterListItem_1.FooterListItem, {
        href: link.href,
        linkText: link.linkText,
        key: index,
        src: link.src
      });
    }))), React.createElement("div", __assign({}, grid.default.col2m), React.createElement(FooterListContainer_1.FooterListContainer, {
      title: "our community"
    }, React.createElement(FooterListItem_1.FooterListItem, {
      href: "https://wwww.headspace.com/blog",
      linkText: "blog"
    })), React.createElement("div", __assign({}, spacing.default.marginTopLarge), React.createElement(FooterListContainer_1.FooterListContainer, {
      title: "about us"
    }, FooterList_1.columnTwoLinks.map(function (link, index) {
      return React.createElement(FooterListItem_1.FooterListItem, {
        href: link.href,
        linkText: link.linkText,
        key: index,
        src: link.src
      });
    })))), React.createElement("div", __assign({}, grid.default.col2m), React.createElement(FooterListContainer_1.FooterListContainer, {
      title: "support"
    }, React.createElement(FooterListItem_1.FooterListItem, {
      href: "https://wwww.help.headspace.com",
      linkText: "help center"
    }), React.createElement(FooterListItem_1.FooterListItem, {
      href: "https://wwww.headspace.com/contact-us",
      linkText: "contact us"
    })), React.createElement("div", __assign({}, spacing.default.marginTopLarge), React.createElement(FooterListContainer_1.FooterListContainer, {
      title: "partnerships"
    }, React.createElement(FooterListItem_1.FooterListItem, {
      href: "https://www.headspace.com/science/meditation-research",
      linkText: "research partners"
    }), React.createElement(FooterListItem_1.FooterListItem, {
      href: "https://www.headspace.com/partners",
      linkText: "brand partners"
    })))), React.createElement("div", __assign({}, hideMobileDisplay, grid.default.col3m), React.createElement(FooterListContainer_1.FooterListContainer, {
      title: "get the app"
    }, FooterList_1.badgeLinks.map(function (link, index) {
      return React.createElement(FooterListItem_1.FooterListItem, {
        href: link.href,
        linkText: link.linkText,
        key: index,
        src: link.src
      });
    })))), React.createElement("div", __assign({}, grid.default.container), React.createElement("div", __assign({}, spacing.default.marginAuto), React.createElement("a", __assign({
      href: "https://instagram.com/headspace/"
    }, hs_web_style_guide_1.css(utils.default.displayInlineBlock), spacing.default.marginLeftSmall, text.default.linkHover), React.createElement(Icon_1.Icon, {
      width: 32,
      height: 32,
      fill: colors_1.comet,
      src: instagram
    })), React.createElement("a", __assign({
      href: "https://twitter.com/Headspace"
    }, hs_web_style_guide_1.css(utils.default.displayInlineBlock), spacing.default.marginLeftSmall, text.default.linkHover), React.createElement(Icon_1.Icon, {
      width: 32,
      height: 32,
      fill: colors_1.comet,
      src: twitter
    })), React.createElement("a", __assign({
      href: "https://www.facebook.com/Headspace"
    }, hs_web_style_guide_1.css(utils.default.displayInlineBlock), spacing.default.marginLeftSmall, text.default.linkHover), React.createElement(Icon_1.Icon, {
      width: 32,
      height: 32,
      fill: colors_1.comet,
      src: facebook
    })), React.createElement("a", __assign({
      href: "http://www.youtube.com/user/Getsomeheadspace"
    }, hs_web_style_guide_1.css(utils.default.displayInlineBlock), spacing.default.marginLeftSmall, text.default.linkHover), React.createElement(Icon_1.Icon, {
      width: 32,
      height: 32,
      fill: colors_1.comet,
      src: youtube
    })))), React.createElement("div", __assign({}, grid.default.container, font.utility4, text.default.cometColor, font.uppercase, text.default.centerTextAlign, spacing.default.paddingTopLarge), React.createElement("div", __assign({}, spacing.default.marginAuto), React.createElement("div", __assign({}, displayDesktopInline), "\xA9 2018 Headspace Inc."), React.createElement("div", __assign({}, displayDesktopInline), React.createElement("a", __assign({
      href: "https://wwww.headspace.com/terms-and-conditions"
    }, spacing.default.marginLeftSmall, hs_web_style_guide_1.css(utils.default.textDecorationNone), text.default.linkHover, text.default.cometColor), "terms & conditions")), React.createElement("div", __assign({}, displayDesktopInline), React.createElement("a", __assign({
      href: "https://wwww.headspace.com/privacy-policy"
    }, spacing.default.marginLeftSmall, hs_web_style_guide_1.css(utils.default.textDecorationNone), text.default.linkHover, text.default.cometColor), "Privacy policy")), React.createElement("div", __assign({}, displayDesktopInline), React.createElement("a", __assign({
      href: "https://wwww.headspace.com/Getsomeheadspace"
    }, spacing.default.marginLeftSmall, hs_web_style_guide_1.css(utils.default.textDecorationNone), text.default.linkHover, text.default.cometColor), "site map"))), React.createElement("div", __assign({}, hs_web_style_guide_1.css(utils.default.showLgUp)), React.createElement(Icon_1.Icon, {
      width: 48,
      height: 48,
      fill: colors_1.jaffa,
      src: arrowUp
    }))));
  };

  return HomepageFooter;
}(React.Component);

exports.HomepageFooter = HomepageFooter;